define(function() {
  var Backbone = require('backbone');
  const IpsModelCollection = require('civicsBase/ipsModelCollection');

  return IpsModelCollection.extend({
    urlRoot: '/delegate/civics-api/api/rhythm/civics',
    url:function(){
      if(this.provider!=null){
        if(this.isEffective) {
          u = this.urlRoot+'/providers/documenttypes/definitions/'+this.encodeComponent(this.provider)+'/documenttypes?isEffective=true';
        } else {
          u = this.urlRoot+'/providers/documenttypes/definitions/'+this.encodeComponent(this.provider)+'/documenttypes/';
        }
      } else {
        u = '/delegate/civics-api/api/rhythm/civics/core/document/definitions';
      }
      return u;
    },
    parse: function(response) {
      this.responseStatus = response.responseStatus;
      return response.data;
    }
  });
})
